import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import { Api } from "../../services/api";

/**
 * Generated class for the LoginByWeixinPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
  segment: "wxlogin/:token",
})
@Component({
  selector: "page-login-by-weixin",
  templateUrl: "login-by-weixin.html",
})
export class LoginByWeixinPage {
  state = "init";

  constructor(
    public navCtrl: NavController,
    private api: Api,
    public navParams: NavParams
  ) {
    document.title = "微信登入";
  }

  confirm() {
    this.api
      .loginByWx(this.navParams.data.token)
      .then((data) => {
        if (data.userid > 0) {
          this.state = "done";
        }
      })
      .catch((err) => {
        if (err.errMsg == "wx not bound") {
          this.state = "notBound";
        } else {
          this.state = "errored";
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/login-by-weixin/login-by-weixin.ts